import React from 'react';

import {
  Image,
  Link,
} from '@consumer-frontend/shared-ui';

import { SecurityWidgets } from './SecurityWidgets';

import '@consumer-bootstrap/index.scss';
import '@consumer-bootstrap/pages/account-home/footer.scss';

const socialIcons: { link: string; name: string; }[] = [
  {
    link: 'https://www.facebook.com/CashNetUSA',
    name: 'facebook',
  },
  {
    link: 'https://www.instagram.com/cashnetusa',
    name: 'instagram',
  },
  {
    link: 'https://twitter.com/cashnetusa',
    name: 'twitterX',
  },
  {
    link: 'https://www.youtube.com/user/CashNetUSATV',
    name: 'youtube',
  },
];

export type SocialTrustedSiteT = React.FC;

export const SocialTrustedSite: SocialTrustedSiteT = () => {
  return (
    <div className="social-trusted-site">
      <div className="footer-logo">
        <Image
          src="/assets/images/cnu_white.svg"
          alt="Cashnetusa Footer Logo"
        />
      </div>
      <Link className="phone mt-5" to="tel:888-801-9075">
        888.801.9075
      </Link>
      <div className="social-links d-flex mt-3">
        {socialIcons.map(({
          name,
          link,
        }) => (
          <Link target="_blank" key={name} to={link}>
            <Image src={`/assets/images/${name}.svg`} alt={name} />
          </Link>
        ))}
      </div>
      <SecurityWidgets />
    </div>
  );
};
